export default __webpack_public_path__ + "static/media/art-sm.6fd5e9f2.jpg";